export default "__VITE_ASSET__Dqs1yI6D__"